import { useContent, imgSrc } from "@/context/ContentContext";

const DEFAULTS = {
  kicker: "Het verhaal achter De Houtregisseur",
  title: "Waarom de regisseur? Omdat elk meubel een eigen script verdient.",
  p1: "Met een speelse knipoog naar de filmwereld neemt René de regie over het hele houtproces: van de eerste schets aan de keukentafel tot de laatste streek olie op het hout. Geen anonieme fabrieksdozen of standaardmaten, maar puur vakwerk.",
  p2: "Of het nu gaat om een specifieke houten kist met handgemaakt sluitwerk, een uniek modulair wijnrek aan een robuuste stenen muur, of een salontafel die exact in die ene lastige hoek past: René denkt actief mee over houtsoort, nerven, verbindingen en afwerking.",
  quote: "Een goed meubel vertelt een verhaal en past naadloos in jouw ruimte.",
  image:
    "https://images.unsplash.com/photo-1631396326646-c06a935ff3a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjYXJwZW50ZXIlMjBwbGFuaW5nJTIwd29vZCUyMHdvcmtzaG9wJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwNTA4NDAzfDA&ixlib=rb-4.1.0&q=85",
};

const feiten = [
  { titel: "100%", sub: "Handgemaakt maatwerk" },
  { titel: "Rijswijk", sub: "Eigen werkplaats" },
  { titel: "Duurzaam", sub: "Hout van kwaliteit" },
];

export const Story = () => {
  const { content } = useContent();
  const story = { ...DEFAULTS, ...(content?.story || {}) };

  return (
    <section id="rene" data-testid="story-section" className="py-24 px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 hr-reveal">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-[#E0D5C7] shadow-xl">
            <img
              src={imgSrc(story.image)}
              alt="René aan het werk in de werkplaats in Rijswijk"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2B231D]/80 via-[#2B231D]/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <span className="text-xs uppercase tracking-widest text-[#E6AF68] font-semibold">
                Meubelmaker & Bedenker
              </span>
              <h3 className="text-2xl font-bold font-display mt-1">René · De Houtregisseur</h3>
              <p className="text-xs text-[#EAE3DA] mt-1">"{story.quote}"</p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 hr-reveal">
          <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">
            {story.kicker}
          </span>
          <h2 className="text-3xl sm:text-4xl font-normal font-display text-[#2B231D] mt-3 mb-6 leading-snug">
            {story.title}
          </h2>
          <div className="space-y-5 text-[#594E44] text-base leading-relaxed">
            <p>{story.p1}</p>
            <p>{story.p2}</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-10 pt-8 border-t border-[#EAE3DA]">
            {feiten.map((f) => (
              <div key={f.titel}>
                <span className="block text-2xl font-bold text-[#2B231D] font-display">{f.titel}</span>
                <span className="text-xs text-[#7A6C60]">{f.sub}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
